export const getDateObjectsObj = (datesFromBackArr) => {
  const result = {}

  datesFromBackArr.forEach((dateArrElement) => {result[dateArrElement.date] = new Date(dateArrElement.date)})

  return result
}
